import React from "react";

import { Container, Row } from "reactstrap";

const EmoneyHeader = () => {
  return (
    <>
      <div className="header bg-gradient-danger pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default EmoneyHeader;
